export type Enum = {
  /**
   * Enum key, e.g. for PaymentTypeEnumEnum
   */
  key: string;
  /**
   * Translated value for enum, e.g. for PaymentTypeEnumEnum
   */
  value: string;
};
